import {
  Copy,
  Heading,
  Image,
  Link,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { formatPenniesToCurrency } from 'src/common/utils/formatPenniesToCurrency';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import {
  statesContent,
  supportEmail,
} from 'src/components/selfService/features/Signup/steps/ValidationStep/constants';
import { ValidationStepStateComponentProps } from 'src/components/selfService/features/Signup/steps/ValidationStep/ValidationStep.utils';

export function ApprovedWithNetTermsState({
  creditLimit,
}: ValidationStepStateComponentProps): JSX.Element | null {
  const { approvedWithNetTerms } = statesContent;

  const { isPhone } = useScreenSizes();
  const textAlign = isPhone ? 'left' : 'center';

  if (creditLimit === null) {
    return null;
  }

  return (
    <>
      <Stack y="sm" alignSelf="center">
        <Image
          width="250px"
          src={approvedWithNetTerms.illustrationUrl}
          alt=""
          role="presentation"
        />
      </Stack>
      <Stack y="sm">
        <Heading variant="h1" textAlign={textAlign}>
          {`${approvedWithNetTerms.title[0]} ${formatPenniesToCurrency(
            creditLimit
          )} ${approvedWithNetTerms.title[1]}`}
        </Heading>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {approvedWithNetTerms.text[0]}
        </Copy>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {approvedWithNetTerms.text[1]}{' '}
          <Link variant="muted" href={`mailto:${supportEmail}`}>
            {supportEmail}
          </Link>
        </Copy>
      </Stack>
    </>
  );
}
